import { render, staticRenderFns } from "./DataVolumeDetail.vue?vue&type=template&id=4d260a14&"
import script from "./DataVolumeDetail.vue?vue&type=script&lang=js&"
export * from "./DataVolumeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports